import React, { lazy, useState } from 'react';
import { useForm  } from 'react-hook-form';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import 'react-datetime/css/react-datetime.css';
import { useTranslation } from 'react-i18next';
import FormSwitch from '../ReactHookFormCustom/FormSwitch';

// This means that the Modal component will not be loaded immediately when the parent component (ConfigureEmailModal) is loaded.
// Instead, it will be loaded only when it is actually needed, i.e., when the isConfigureEmailModalOpen prop is true and the Modal component needs to be rendered.
const Modal = lazy(() => import('reactstrap/lib/Modal'));

const ConfigureKanbanAutomatizationsModal = ({ isConfigureAutomatizationsModalOpen,  toggleIsConfigureAutomatizationsModalOpen, selectedColumn }) => {
  const { t } = useTranslation();
  const [isEmailNotificationChecked, setIsEmailNotificationChecked] = useState(false);
  const [isSlackNotificationChecked, setIsSlackNotificationChecked] = useState(false);
  const [isTeamsNotificationChecked, setIsTeamsNotificationChecked] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const handleValidSubmit = (data) => {
    toggleModalLocal();
  };

  const toggleModalLocal = () => {
    toggleIsConfigureAutomatizationsModalOpen();
    reset();
  };
  
  return (
    <Modal isOpen={isConfigureAutomatizationsModalOpen} centered className="modal-lg">
      <ModalHeader>
        <h3 className="d-flex align-items-center">
          <i className="fa mr-2 icon-earphones-alt"></i>{t('kanban.FOLLOW_UP')}
        </h3>
      </ModalHeader>
      <form onSubmit={handleSubmit((data) => handleValidSubmit(data))}>
        <ModalBody>
          {/* <FormInput 
            id='todo' 
            register={register} 
            errors={errors} 
            label="todo" 
            
            required={true}/>
            <FormInput 
              id='todo2' 
              register={register} 
              errors={errors} 
              label="todo2" 
              required={true}/> */}
            <label className="switch d-flex align-items-center py-2">
              <input 
                id="chk-fixed"
                type="checkbox" 
                name="isFixed" 
                checked={isEmailNotificationChecked} 
                onChange={() => setIsEmailNotificationChecked(!isEmailNotificationChecked)} 
              />
              <span></span>
              <div className="px-2">Send me an email if application state is unchanged for 7 days.</div>
            </label>
            {/* <div className="checkbox c-checkbox">
              <label>
                <input 
                    id="checkboxTmp" 
                    type="checkbox" 
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}/>
                <span className="fa fa-check"></span> Automatization 2 
              </label>
            </div> */}
            {/* <div className="d-flex align-items-center"> */}
              <FormSwitch
                id="testSwitch2"
                label='Send me an Slack notification if application state is unchanged for 7 days.'
                isChecked={isSlackNotificationChecked}
                setIsChecked={() => setIsSlackNotificationChecked(!isSlackNotificationChecked)}
                register={register('testSwitch2')}
            />
              {/* <div>
                <div className="checkbox c-checkbox pt-2">
                  <label>
                    <input 
                      id="checkboxTmp" 
                      type="checkbox" 
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                    />
                    <span className="fa fa-check"></span> Automatization 3 
                  </label>
                </div>
              </div>
            </div> */}
            <FormSwitch
              id="testSwitch"
              label='Send me an Teams notification if application state is unchanged for 7 days.'
              isChecked={isTeamsNotificationChecked}
              setIsChecked={() => setIsTeamsNotificationChecked(!isTeamsNotificationChecked)}
              register={register('testSwitch')}
            />
        </ModalBody>
        <ModalFooter>
          <Button color="primary">{t('common.SAVE')}</Button>
                    &nbsp;
          <Button color="secondary" onClick={() => toggleModalLocal()}>
            {t('common.CANCEL')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ConfigureKanbanAutomatizationsModal;